module.exports = __webpack_public_path__ + "static/media/English.73b5c2f6.svg";